import AlertsComponent from './components/Alerts';
import MetricsComponent from './components/Metrics';
import UsersComponent from './components/Users';
import ResidentsComponent from './components/Residents';
import ProfileComponent from './components/Profile';

const METRICS_PATH = '/metrics';
const ALERTS_PATH = '/alerts';
const USERS_PATH = '/users';
const PROFILE_PATH = '/profile';
const RESIDENTS_PATH = '/residents';

export default {
  paths: {
    metrics: METRICS_PATH,
    alerts: ALERTS_PATH,
    users: USERS_PATH,
    residents: RESIDENTS_PATH,
    profile: PROFILE_PATH,
  },
  navs: [
    {
      label: 'Alerts',
      path: ALERTS_PATH,
      icon: 'icon-bell',
      component: AlertsComponent,
    },
    {
      label: 'Metrics',
      path: METRICS_PATH,
      icon: 'icon-activity',
      component: MetricsComponent,
    },
    {
      label: 'Staff',
      path: USERS_PATH,
      icon: 'icon-clipboard',
      component: UsersComponent,
    },
    {
      label: 'Residents',
      path: RESIDENTS_PATH,
      icon: 'icon-users',
      component: ResidentsComponent,
    },
    {
      label: 'Profile',
      path: PROFILE_PATH,
      icon: 'icon-user',
      component: ProfileComponent,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/nav.js